// extracted by mini-css-extract-plugin
export default {"uiLightboxImg":"UiLightbox_uiLightboxImg__oXcP","imageFadeIn":"UiLightbox_image-fade-in_PoVsu","uiLightboxBackdrop":"UiLightbox_uiLightboxBackdrop_br0qP"};